import { render, staticRenderFns } from "./ownerlogin.vue?vue&type=template&id=11f0d2b2&scoped=true&"
import script from "./ownerlogin.vue?vue&type=script&lang=js&"
export * from "./ownerlogin.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/login.css?vue&type=style&index=0&id=11f0d2b2&scoped=true&lang=css&"
import style1 from "./ownerlogin.vue?vue&type=style&index=1&id=11f0d2b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f0d2b2",
  null
  
)

export default component.exports